import cn from 'classnames';
import styles from './styles.css';

const CustomCell = (
  id,
  value = '',
  className,
  isHidden = false,
  otherProps = {},
  parent = 'td',
) => ({
  id,
  render: () => (isHidden ? null : value),
  getCellProps: () => ({
    className: isHidden
      ? 'hidden'
      : cn(className, styles.custom_cell, styles.table_cell),
    ...otherProps,
  }),
  parent,
});

export default CustomCell;
